import { useInfiniteQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  EconomicsResponseInput,
  economicsResponseInputSchema,
  financialEvents,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const US_COUNTRY_CODE = 'US';

const QUERY_KEY_ECONOMICS_EVENTS = 'QUERY_KEY_ECONOMICS_EVENTS';
const PAGE_SIZE = 20;

export interface UseEconomicsEventsProps {
  from: string;
  to: string;
  countries?: string[];
  pageSize?: number;
}

export const useEconomicsEvents = ({
  from,
  to,
  countries,
  pageSize = PAGE_SIZE,
}: UseEconomicsEventsProps) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_ECONOMICS_EVENTS, to, from, countries, pageSize],
    queryFn: async ({ signal, pageParam }) => {
      const { path, schema } = financialEvents.getEconomics;
      const url = path({
        from,
        to,
        countries,
        page: pageParam,
        pageSize,
      });

      const response = await wretchRequest<EconomicsResponseInput>(url, {
        schema,
        signal,
      });

      return economicsResponseInputSchema.parse(response).economics;
    },
    initialPageParam: 1,
    staleTime: getTimeTillEndOfDayMs(),
    getNextPageParam: (lastPage, _, lastPageParam) => {
      if (lastPage.length === 0) {
        return undefined;
      } else if (lastPage.length === pageSize) {
        return lastPageParam + 1;
      } else {
        return undefined;
      }
    },
  });
